(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    /* BISOU PRODUCT PAGE CUSTOMIZATION — GIFT NOTE
     Modal behavior and line item property updates for the native product form.
  */
  (() => {
    const giftNotes = document.querySelectorAll('[data-bisou-gift-note]');

    giftNotes.forEach((giftNote) => {
      const trigger = giftNote.querySelector('[data-bisou-gift-note-open]');
      const modal = giftNote.querySelector('[data-bisou-gift-note-modal]');
      const saveButton = giftNote.querySelector('[data-bisou-gift-note-save]');
      const closeButtons = giftNote.querySelectorAll('[data-bisou-gift-note-close]');
      const fields = giftNote.querySelectorAll('[data-bisou-gift-note-field]');
      const propertyInputs = giftNote.querySelectorAll('[data-bisou-gift-note-property]');
      let lastFocusedElement = null;

      if (!trigger || !modal || !saveButton) return;

      const getField = (key) => giftNote.querySelector(`[data-bisou-gift-note-field="${key}"]`);
      const getProperty = (key) => giftNote.querySelector(`[data-bisou-gift-note-property="${key}"]`);
      const focusableSelector = 'button, [href], input, textarea, select, [tabindex]:not([tabindex="-1"])';

      const syncSavedState = () => {
        const hasValue = Array.from(propertyInputs).some((input) => input.value.trim() !== '' && !input.disabled);
        giftNote.classList.toggle('is-saved', hasValue);
        trigger.setAttribute('aria-pressed', hasValue ? 'true' : 'false');
        const savedLabel = giftNote.querySelector('.bisou-product-gift-note__saved');
        if (savedLabel) savedLabel.hidden = !hasValue;
      };

      const openModal = () => {
        lastFocusedElement = document.activeElement;
        modal.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('bisou-gift-note-open');
        const firstField = getField('from') || modal.querySelector(focusableSelector);
        window.setTimeout(() => firstField?.focus(), 20);
      };

      const closeModal = () => {
        modal.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('bisou-gift-note-open');
        lastFocusedElement?.focus?.();
      };

      const saveNote = () => {
        let hasAnyValue = false;

        fields.forEach((field) => {
          const key = field.getAttribute('data-bisou-gift-note-field');
          const propertyInput = getProperty(key);
          if (!propertyInput) return;

          const value = field.value.trim();
          propertyInput.value = value;
          propertyInput.disabled = value === '';
          if (value !== '') hasAnyValue = true;
        });

        if (!hasAnyValue) {
          propertyInputs.forEach((input) => {
            input.value = '';
            input.disabled = true;
          });
        }

        syncSavedState();
        closeModal();
      };

      trigger.addEventListener('click', openModal);
      saveButton.addEventListener('click', saveNote);
      closeButtons.forEach((button) => button.addEventListener('click', closeModal));

      modal.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          closeModal();
          return;
        }

        if (event.key !== 'Tab') return;

        const focusable = Array.from(modal.querySelectorAll(focusableSelector)).filter((element) => !element.disabled && element.offsetParent !== null);
        if (!focusable.length) return;

        const first = focusable[0];
        const last = focusable[focusable.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });

      syncSavedState();
    });
  })();
  /* END BISOU PRODUCT PAGE CUSTOMIZATION — GIFT NOTE */

  /* BISOU PRODUCT PAGE CUSTOMIZATION — DELIVERY COUNTDOWN
     Uses Tampa Bay time and keeps the late-order message concierge-friendly after the 8 PM cutoff.
  */
  (() => {
    const deliveryCards = document.querySelectorAll(
      '.bisou-main-product-buy-area [data-bisou-delivery-countdown]'
    );

    if (!deliveryCards.length) return;

    const cutoffMinutes = 20 * 60;
    const tampaTimeFormatter = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/New_York',
      hourCycle: 'h23',
      hour: '2-digit',
      minute: '2-digit',
    });

    const getTampaMinutes = () => {
      const parts = tampaTimeFormatter.formatToParts(new Date());
      const hour = Number(parts.find((part) => part.type === 'hour')?.value || 0);
      const minute = Number(parts.find((part) => part.type === 'minute')?.value || 0);
      return hour * 60 + minute;
    };

    const updateDeliveryMessage = () => {
      const currentMinutes = getTampaMinutes();
      const isBeforeCutoff = currentMinutes < cutoffMinutes;
      const remainingMinutes = Math.max(0, cutoffMinutes - currentMinutes);
      const hours = Math.floor(remainingMinutes / 60);
      const minutes = remainingMinutes % 60;

      deliveryCards.forEach((card) => {
        const body = card.querySelector('[data-bisou-delivery-body]');
        const micro = card.querySelector('[data-bisou-delivery-micro]');

        if (!body || !micro) return;

        if (isBeforeCutoff) {
          body.textContent = `Order within ${hours}h ${minutes}m and we’ll deliver today.`;
          micro.textContent = 'Same-day cutoff: 8:00 PM';
        } else {
          body.textContent =
            'Need it today? Place your order and we’ll confirm the earliest available delivery time.';
          micro.textContent = 'Concierge delivery available by request.';
        }
      });
    };

    updateDeliveryMessage();
    window.setInterval(updateDeliveryMessage, 30000);
  })();
  /* END BISOU PRODUCT PAGE CUSTOMIZATION — DELIVERY COUNTDOWN */
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["variant-picker"] && !Shopify.designMode) return;
  try {
    /* BISOU PRODUCT PAGE CUSTOMIZATION — SIZE TIERS
     Keeps the approved main Add to Cart price label synchronized after a native tier selection.
  */
  (() => {
    const buyArea = document.querySelector('.bisou-main-product-buy-area');
    const form = buyArea?.querySelector('form') || buyArea?.closest('form');
    const button = buyArea?.querySelector(
      'button[ref="addToCartButton"][name="add"], button[type="submit"][name="add"]'
    );
    const label = button?.querySelector('.add-to-cart-text__content');
    const variantInput = form?.querySelector('input[name="id"]');
    const priceMapScript = buyArea?.querySelector('[data-bisou-atc-price-map]');
    const baseLabel = buyArea?.getAttribute('data-bisou-atc-label') || 'ADD TO CART';
    let priceMap = {};

    if (!buyArea || !button || !label) return;

    try {
      priceMap = priceMapScript ? JSON.parse(priceMapScript.textContent || '{}') : {};
    } catch (error) {
      priceMap = {};
    }

    const updateLabel = () => {
      if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;

      const price = priceMap[variantInput?.value] || buyArea.getAttribute('data-bisou-atc-price');
      if (price) label.textContent = `${baseLabel} · ${price}`;
    };

    updateLabel();
    form?.addEventListener('change', () => window.setTimeout(updateLabel, 0));

    if (variantInput) {
      const observer = new MutationObserver(updateLabel);
      observer.observe(variantInput, { attributes: true, attributeFilter: ['value'] });
    }
  })();

  (() => {
    const variantPicker = document.querySelector(
      '.product-information .variant-picker[ref="mainVariantPicker"]'
    );

    if (!variantPicker) return;

    const normalizeTierValue = (value) =>
      String(value || '')
        .trim()
        .toLowerCase()
        .replace(/[-_]+/g, ' ')
        .replace(/\s+/g, ' ');

    const applyTierDisplay = () => {
      variantPicker
        .querySelectorAll('.variant-option__button-label input')
        .forEach((input) => {
          const normalizedValue = normalizeTierValue(input.value);
          const card = input.closest('.variant-option__button-label');
          if (!card) return;

          const existingLabel = card.querySelector('.bisou-deluxe-tier-label');
          if (normalizedValue === 'deluxe') {
            card.setAttribute('data-bisou-deluxe-tier', '');
            existingLabel?.remove();
          } else {
            card.removeAttribute('data-bisou-deluxe-tier');
            existingLabel?.remove();
          }

          if (normalizedValue === 'over the top' || normalizedValue === 'grand' || normalizedValue === 'premium') {
            const title = card.querySelector('.variant-title');
            const description = card.querySelector('.variant-sub');

            if (title && title.textContent.trim() !== 'PREMIUM') {
              title.textContent = 'PREMIUM';
            }

            if (description && description.textContent.trim() !== 'Finest Version') {
              description.textContent = 'Finest Version';
            }
          }
        });
    };

    let pendingTierDisplay = false;
    const scheduleTierDisplay = () => {
      if (pendingTierDisplay) return;
      pendingTierDisplay = true;

      window.requestAnimationFrame(() => {
        pendingTierDisplay = false;
        applyTierDisplay();
      });
    };

    applyTierDisplay();
    variantPicker.addEventListener('change', scheduleTierDisplay);
    document.addEventListener('variant:update', scheduleTierDisplay);
    document.addEventListener('product:variant-change', scheduleTierDisplay);

    const observer = new MutationObserver(scheduleTierDisplay);
    observer.observe(variantPicker, {
      childList: true,
      characterData: true,
      subtree: true,
    });
  })();

  (() => {
    const variantPicker = document.querySelector(
      '.product-information .variant-picker[ref="mainVariantPicker"]'
    );

    if (!variantPicker) return;

    const formatCardPrices = () => {
      variantPicker.querySelectorAll('.variant-price').forEach((price) => {
        const currentText = price.textContent.trim();
        const shortText = currentText.replace(/(\$\s?[\d,]+)\.00(?=\s|$)/g, '$1');

        if (shortText !== currentText) {
          price.textContent = shortText;
        }
      });
    };

    formatCardPrices();

    const observer = new MutationObserver(formatCardPrices);
    observer.observe(variantPicker, {
      childList: true,
      characterData: true,
      subtree: true,
    });
  })();
  /* END BISOU PRODUCT PAGE CUSTOMIZATION — SIZE TIERS */
  } catch(e) { console.error(e); }
})();

})();
